import { LoanCalculator } from '../../../../components/LoanCalculator';
import { LoanCalculatorContent } from '../../../../components/LoanCalculator/components/LoanCalculatorContent';
import { LoanCalculatorForm } from '../../../../components/LoanCalculator/components/LoanCalculatorForm';
import React, { useContext } from 'react';
import { OfferContext } from '../../context';

export const Calculator = () => {
    const { calculator_enabled, calculator_components } =
        useContext(OfferContext);

    if (
        !calculator_enabled ||
        !calculator_components ||
        !calculator_components.length
    )
        return null;

    return (
        <>
            {calculator_components.map((calculator: any) => {
                const {
                    heading,
                    field_label_1: fieldLabel1,
                    field_label_2: fieldLabel2,
                    content,
                } = calculator;

                switch (calculator.component) {
                    case 'Loan Calculator':
                    default:
                        return (
                            <LoanCalculator
                                fieldOneLabel={fieldLabel1}
                                fieldTwoLabel={fieldLabel2}
                                key={fieldLabel1}
                            >
                                {heading && <h1>{heading}</h1>}
                                <LoanCalculatorForm />
                                <LoanCalculatorContent content={content} />
                            </LoanCalculator>
                        );
                }
            })}
        </>
    );
};
